import { render, staticRenderFns } from "./faceChatView.vue?vue&type=template&id=17776722&scoped=true"
import script from "./faceChatView.vue?vue&type=script&lang=js"
export * from "./faceChatView.vue?vue&type=script&lang=js"
import style0 from "./faceChatView.vue?vue&type=style&index=0&id=17776722&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17776722",
  null
  
)

export default component.exports